import { useTranslation } from "react-i18next";

import { BrandLogo } from "@/components/brand-logo";
import { Button } from "@/components/ui/button";

/** Shown by the app-wide error boundary (`main.tsx`) when a page crashes while rendering. */
export function ErrorFallback() {
  const { t } = useTranslation();
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <BrandLogo className="h-12 text-2xl" />
      <h1 className="font-heading text-primary mt-12 text-3xl font-bold">{t("errorPage.title")}</h1>
      <p className="text-muted mt-4 text-lg">{t("errorPage.body")}</p>
      <Button className="mt-8 px-6" onClick={() => window.location.reload()}>
        {t("errorPage.reload")}
      </Button>
    </div>
  );
}
